// 辅导员管理
export default [
  {
    path: '/instructor/instructorManage',
    component: resolve => require(['@/pages/instructor/instructorManageNew.vue'], resolve),
    name:'instructorManage',
    meta: {
      title: '辅导员管理'
    }
  },
  {
    path: '/instructor/appraisal',
    component: resolve => require(['@/pages/instructor/appraisal.vue'], resolve),
    name:'appraisal',
    meta: {
      title: '辅导员测评'
    }
  },
  {
    path: '/instructor/information',
    component: resolve => require(['@/pages/instructor/instructorInformation.vue'], resolve),
    name:'information',
    meta: {
      title: '辅导员信息'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/instructor.js